import { Injectable, inject } from "@angular/core";
import { DeliveryMethodsService, IFirmDeliveryMethodsService } from "../shared";
import { IDashboardModel, isiFirmTaxDashboard } from "../views-interfaces/dashboard-model.interface";
import { ITranslateObject, TaxprepT1Card } from "../views-interfaces";
import { MultiSelectModel, Option } from "./filter-types";

@Injectable({
    providedIn: "root",
})
export class DeliveryMethodsFilterGeneratorService {
    private readonly deliveryMethodsService = inject(DeliveryMethodsService);
    private readonly iFirmDeliveryMethodsService = inject(IFirmDeliveryMethodsService);
    private isiFirmDeliveryMethods: boolean;

    constructor() {}

    async generateModel(selection: Option[], currentDashboard: IDashboardModel) {
        let sortedOptions: unknown;
        if (isiFirmTaxDashboard(currentDashboard) && currentDashboard.TaxYear >= 2025) {
            this.isiFirmDeliveryMethods = true;
            sortedOptions = (await this.iFirmDeliveryMethodsService.getiFirmDeliveryMethods()).map((method) => ({
                text: method as { "en-CA": string; "fr-CA": string },
                value: method.Id.toString(),
            }));
        } else {
            this.isiFirmDeliveryMethods = false;
            const deliveryMethods = this.deliveryMethodsService.getDeliveryMethodsListForFilters(currentDashboard);
            const options: Option[] = Object.entries(deliveryMethods).map(([key, value]: [string, any]) => ({
                text: value as { "en-CA": string; "fr-CA": string },
                value: key,
            }));

            // Sort options to put "None" first
            sortedOptions = options.sort((a, b) => {
                if (a.value === DeliveryMethodsService.NONE_DELIVERY_METHOD_ID) return -1;
                if (b.value === DeliveryMethodsService.NONE_DELIVERY_METHOD_ID) return 1;
                return Number.parseInt(a.value.toString()) - Number.parseInt(b.value.toString());
            });
        }

        return {
            label: "FiltersSidebar.Labels.DeliveryMethod",
            allOptions: sortedOptions,
            applicableOptions: sortedOptions,
            selection,
        } as MultiSelectModel;
    }

    getPrintDescription(
        label: string | ITranslateObject,
        selectedOptions: Option[],
    ): { label: string | ITranslateObject; values: (string | ITranslateObject)[] } | null {
        if (!selectedOptions || selectedOptions.length === 0) {
            return null;
        } else {
            return {
                label,
                values: selectedOptions.map((value) => {
                    return value.text;
                }),
            };
        }
    }

    generateFilter(selectedValues: string[]) {
        if (!selectedValues || selectedValues.length === 0) {
            return null;
        }

        return (card: TaxprepT1Card) => {
            // Handle "None" option - show cards with no delivery method
            if (
                !this.isiFirmDeliveryMethods &&
                selectedValues.includes(DeliveryMethodsService.NONE_DELIVERY_METHOD_ID) &&
                (card.deliveryMethod === null || card.deliveryMethod === undefined)
            ) {
                return true;
            }

            const otherSelectedValues = selectedValues.filter(
                (value) => value !== DeliveryMethodsService.NONE_DELIVERY_METHOD_ID || this.isiFirmDeliveryMethods,
            );
            if (otherSelectedValues.length > 0 && card.deliveryMethod !== null && card.deliveryMethod !== undefined) {
                return otherSelectedValues.includes(card.deliveryMethod.toString());
            }

            return false;
        };
    }
}
